import { LayoutList, LayoutGrid } from "lucide-react";
import { useTranslation } from "react-i18next";

const ViewModeToggle = ({ value, onChange }) => {
  const { t } = useTranslation('common');

  const baseBtn = "flex items-center justify-center w-9 h-8 transition-colors";
  const activeStyle = { color: "#92004D", backgroundColor: "#fdf2f7" };
  const inactiveStyle = { color: "#9ca3af", backgroundColor: "#fff" };

  return (
    <div
      className="inline-flex items-center"
      style={{ border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden" }}
    >
      <button
        type="button"
        onClick={() => onChange("table")}
        title={t('viewToggle.table')}
        aria-label={t('viewToggle.table')}
        className={baseBtn}
        style={value === "table" ? activeStyle : inactiveStyle}
      >
        <LayoutList size={16} />
      </button>
      <div style={{ width: 1, height: 20, backgroundColor: "#e5e7eb" }} />
      <button
        type="button"
        onClick={() => onChange("cards")}
        title={t('viewToggle.cards')}
        aria-label={t('viewToggle.cards')}
        className={baseBtn}
        style={value === "cards" ? activeStyle : inactiveStyle}
      >
        <LayoutGrid size={16} />
      </button>
    </div>
  );
};

export default ViewModeToggle;
